import { isPhoneNumberValid } from 'utils/phoneNumber';
import { RequiredErrorMessage, zNonEmptyString } from 'utils/validators/zodHelpers';
import { z } from 'zod';

const baseSchema = z.object({
  name: z.string().optional(),
  officeName: z.string().optional(),
  phone: z
    .string(RequiredErrorMessage)
    .optional()
    .refine(
      d => {
        if (!d) return true;
        return isPhoneNumberValid(d);
      },
      { message: 'Invalid phone number' },
    ),
  website: z.string().optional(),
});

const optionalSchema = baseSchema.extend({
  physicianOrderRequired: z.literal(false),
});

const requiredSchema = baseSchema.extend({
  physicianOrderRequired: z.literal(true),
  name: zNonEmptyString,
  officeName: zNonEmptyString,
});

export const PCPInfoSchema = z.discriminatedUnion('physicianOrderRequired', [optionalSchema, requiredSchema]);
